import { render } from "./IconSyncProblem.vue?vue&type=template&id=689b0ed0"
import script from "./IconSyncProblem.vue?vue&type=script&lang=js"
export * from "./IconSyncProblem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__